import { useNavigate } from "react-router-dom";

import Button from "../components/layout/Button";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  // 'handleBackToDashboardButton' function is called when the "Back to Dashboard" button is clicked.
  // It uses the `navigate` function (from the useNavigate hook) to redirect the user to the route path of the application.
  const handleBackToDashboardButton = () => {
    navigate("/");
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">
      <div className="text-center">
        <div className=" bg-white p-4 p-md-5 rounded-3 shadow border">
          <h2 className="display-1 fw-black mb-3">404</h2>
          <h3 className="h2 fw-bold mb-3 page-not-found__title">Page Not Found</h3>
          <p className="lead mb-4 page-not-found__message">
            The page you&apos;re looking for doesn&apos;t exist.
          </p>

          <div className="justify-content-center">
            <Button onClick={handleBackToDashboardButton}>Back to Dashboard</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
